export const getDestinationEmail = (formType, enquiryType, caseType) => {

  if (enquiryType === 'option1') {
    return 'cstanley@pogustgoodhead.com';
  }
  if (enquiryType === 'option2') {
    return 'cstanley@pogustgoodhead.com';
  }

  return 'cstanley@pogustgoodhead.com';
};
